import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ISbStoryData } from '@storyblok/js';
import { Subscription } from 'rxjs';
import { StoryblokService } from 'src/app/services/storyblok.service';
import { StoryblokRootComponent } from '../components/storyblok-root/storyblok-root.component';
import { StoryblokCta, StoryblokImage } from '../storyblok-types';

@Component({
  selector: 'app-storyblok-page',
  standalone: true,
  templateUrl: './storyblok-page.component.html',
  styleUrls: ['./storyblok-page.component.scss'],
  imports: [StoryblokRootComponent],
})
export class StoryblokPageComponent implements OnDestroy {
  storySub: Subscription;
  routeSub: Subscription;
  story!: ISbStoryData;
  darkHeader: boolean;
  prefooter: {
    cta: StoryblokCta[];
    _uid: string;
    image: StoryblokImage;
    component: 'preFooter';
    _editable: string;
  };
  hasHomeTeaser: boolean;
  blurOverlay: StoryblokImage;
  topBlur: StoryblokImage;
  verticalDottedLines: boolean;
  extraDataMap: Map<
    string,
    {
      [key: string]: unknown;
    }
  >;

  constructor(private route: ActivatedRoute, private storyblokService: StoryblokService) {
    this.routeSub = this.route.data.subscribe(data => {
      this.story = data['story'];
      this.extraDataMap = new Map();
      this.onChanges();
    });
    this.storySub = this.storyblokService.onUpdates.subscribe(story => {
      if (!story) return;
      if (this.story?.id === story.id) {
        Object.assign(this.story, story);
        this.onChanges();
      }
    });
  }

  onChanges() {
    if (!this.story) return;
    if (this.story.content.component !== 'root') return;
    this.darkHeader = ['dark', 'black'].includes(this.story.content.background);
    this.hasHomeTeaser = this.story.content.body?.[0]?.component === 'HomeTeaser';
    if (this.hasHomeTeaser) {
      this.darkHeader = true;
    }
    this.prefooter = this.story.content.preFooter?.[0];
    this.blurOverlay = this.story.content.blurOverlay;
    this.topBlur = this.story.content.topBlur;
    this.verticalDottedLines = this.story.content.verticalDottedLines;
    this.extraDataMap.set('TableOfContents', {
      story: this.story,
    });
    this.extraDataMap.set('ContentGroup', {
      extraDataMap: this.extraDataMap,
    });
  }

  ngOnDestroy() {
    this.storySub.unsubscribe();
    this.routeSub.unsubscribe();
  }
}
